import {Action} from "../../data/ActionTypes";

export function changeDataState(data) {
    return {
        type: Action.Data.CHANGE_STATE,
        data
    }
}